import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';
import { siteInfo } from '../config/theme';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>{siteInfo.companyName}</h3>
            <p>{siteInfo.tagline}</p>
            <div className="social-links">
              <a href={siteInfo.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook /></a>
              <a href={siteInfo.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
              <a href={siteInfo.social.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Our Services</h4>
            <ul>
              <li><Link to="/services/building-demolition">Building Demolition</Link></li>
              <li><Link to="/services/earthwork">Earth Work</Link></li>
              <li><Link to="/services/building-materials">Building Material Suppliers</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Equipment for Rent</h4>
            <ul>
              <li><Link to="/services/excavator-breaker-rent">Excavator Breaker Rent</Link></li>
              <li><Link to="/services/mini-road-roller-rent">Mini Road Roller Rent</Link></li>
              <li><Link to="/services/soil-compactor-rent">Soil Compactor Rent</Link></li>
              <li><Link to="/services/excavator-rent">Excavator Rent</Link></li>
              <li><Link to="/services/jcb-rent">JCB Rent</Link></li>
              <li><Link to="/services/jcb-breaker-rent">JCB Breaker Rent</Link></li>
              <li><Link to="/services/tipper-rent">Tipper Rent</Link></li>
              <li><Link to="/services/open-platform-truck-rent">Open Platform Truck Rent</Link></li>
              <li><Link to="/services/bobcat-rent">Bobcat Rent</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Building Materials</h4>
            <ul>
              <li><Link to="/services/m-sand">M Sand</Link></li>
              <li><Link to="/services/p-sand">P Sand</Link></li>
              <li><Link to="/services/wet-mix-macadam">Wet Mix Macadam</Link></li>
              <li><Link to="/services/coarse-aggregates">Coarse Aggregates</Link></li>
              <li><Link to="/services/red-soil">Red Soil</Link></li>
              <li><Link to="/services/gravel-filling">Gravel Filling</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul className="contact-list">
              <li>
                <FaMapMarkerAlt />
                <span>{siteInfo.location}</span>
              </li>
              <li>
                <FaPhone />
                <a href={`tel:${siteInfo.phone}`}>{siteInfo.phone}</a>
              </li>
              <li>
                <FaEnvelope />
                <a href={`mailto:${siteInfo.email}`}>{siteInfo.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} {siteInfo.companyName}. All Rights Reserved.</p>
          <p className="developer-credit">
            Developed By <a href="https://varnyxtechnologies.com" target="_blank" rel="noopener noreferrer">Varnyx Technologies</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
